import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path1/apps/web/src/app/(front)/(pages)/blog/BlogList.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path1/apps/web/src/app/(front)/(pages)/styles.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path1/packages/i18n/src/Trans.tsx");
